"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataUiBlueprints = exports.DataUiTypeOrmBuilder = void 0;
const typeorm_1 = require("typeorm/browser");
const common_1 = require("../transformers/common");
const cache_map_1 = require("../util/cache-map");
const decorators_1 = require("./decorators");
const helpers_1 = require("./helpers");
const typeorm_entity_metadata_1 = require("./typeorm-entity-metadata");
const types_1 = require("./types");
class DataUiTypeOrmBuilder {
    constructor(entity, connection) {
        this.connection = connection !== null && connection !== void 0 ? connection : (0, typeorm_1.getConnection)();
        this.entity = (0, helpers_1.getEntityConstructor)(entity);
    }
    getProperties() {
        if (!this.properties) {
            this.properties = (0, typeorm_entity_metadata_1.getTypeormEntityProperties)(this.entity, this.connection);
            this.properties.sort((a, b) => {
                const aScore = a.isPrimary
                    ? 0
                    : a.isCreateDate ||
                        a.isUpdateDate ||
                        a.isDeleteDate ||
                        a.propertyName === 'apiId'
                        ? Number.MAX_SAFE_INTEGER
                        : 1;
                const bScore = b.isPrimary
                    ? 0
                    : b.isCreateDate ||
                        b.isUpdateDate ||
                        b.isDeleteDate ||
                        b.propertyName === 'apiId'
                        ? Number.MAX_SAFE_INTEGER
                        : 1;
                return aScore - bScore;
            });
        }
        return this.properties;
    }
    getPermissions() {
        return (0, helpers_1.getDataUiPermissions)(this.entity);
    }
    getSearchFields() {
        const result = {};
        this.getProperties()
            .map((c) => ({
            c,
            search: (0, helpers_1.getDataUiSearchConfig)(this.entity, c.propertyName),
        }))
            .forEach((d) => {
            if (!d.search) {
                return;
            }
            Object.entries(d.search).forEach(([group, includeInSearch]) => {
                if (!result[group]) {
                    result[group] = [];
                }
                if (includeInSearch) {
                    result[group].push(d.c.propertyName);
                }
            });
        });
        return result;
    }
    getColumnsByGroup() {
        var _a, _b, _c, _d, _e, _f, _g;
        const result = {};
        const entityLayout = (0, helpers_1.getDataUiDefaultLayoutConfig)(this.entity);
        for (const column of this.getProperties()) {
            const entity = !column.isEmbed ? this.entity : column.embeds.type;
            const description = (0, helpers_1.getDataUiLayoutConfig)(entity, column.propertyName);
            for (const groupName of Object.keys(decorators_1.DataUIGroups)) {
                if (!result[groupName]) {
                    result[groupName] = {};
                }
                const group = result[groupName];
                const columnType = column.columnType;
                const overrides = (0, helpers_1.getDataUiOverride)(entity, column.propertyName);
                const searchField = (0, helpers_1.getDataUiSearchConfig)(this.entity, column.propertyName);
                if ((columnType === null || columnType === void 0 ? void 0 : columnType.type) === types_1.SimplifiedColumnTypeEnum.TEXT) {
                    if (overrides && overrides.length) {
                        columnType.length = overrides.length;
                    }
                }
                group[column.propertyPath] = {
                    propertyName: column.propertyName,
                    propertyPath: column.propertyPath,
                    label: overrides === null || overrides === void 0 ? void 0 : overrides.label,
                    columnType,
                    isPrimary: column.isPrimary,
                    isReadOnly: (overrides === null || overrides === void 0 ? void 0 : overrides.generated) || (overrides === null || overrides === void 0 ? void 0 : overrides.readOnly) || column.isReadOnly,
                    isGenerated: (overrides === null || overrides === void 0 ? void 0 : overrides.generated) || column.isGenerated,
                    isArray: column.isArray,
                    isCreateDate: column.isCreateDate,
                    isUpdateDate: column.isUpdateDate,
                    isDeleteDate: column.isDeleteDate,
                    isNullable: column.isNullable,
                    hasDefaultValue: column.hasDefaultValue,
                    defaultValue: column.defaultValue,
                    isRelation: column.isRelation,
                    isRelationOwner: column.isRelationOwner,
                    enumValues: (_a = column.enumValues) !== null && _a !== void 0 ? _a : (0, helpers_1.getDataUiEnumValues)(entity, column.propertyName),
                    enumValuesWithKeys: (0, helpers_1.getDataUiEnumValuesWithKeys)(entity, column.propertyName),
                    enumValuesFromPicklist: (0, helpers_1.getDataUiEnumValuesFromPicklist)(entity, column.propertyName),
                    relationType: column.relationType,
                    relationReferencedColumn: column.relationReferencedColumn,
                    relationEntity: column.relationEntity,
                    relationInverseSidePropertyPath: column.relationInverseSidePropertyPath,
                    isEagerRelation: column.isEagerRelation,
                    isCascadeRelation: (_b = overrides === null || overrides === void 0 ? void 0 : overrides.isCascadeRelation) !== null && _b !== void 0 ? _b : column.isCascadeRelation,
                    cascadeRelations: column.cascadeRelations,
                    mimeType: overrides === null || overrides === void 0 ? void 0 : overrides.mimeType,
                    isURI: overrides === null || overrides === void 0 ? void 0 : overrides.isURI,
                    showInline: overrides === null || overrides === void 0 ? void 0 : overrides.showInline,
                    hide: (_d = (_c = description === null || description === void 0 ? void 0 : description[groupName]) === null || _c === void 0 ? void 0 : _c.hide) !== null && _d !== void 0 ? _d : (_e = entityLayout === null || entityLayout === void 0 ? void 0 : entityLayout[groupName]) === null || _e === void 0 ? void 0 : _e.hide,
                    description: (0, helpers_1.getDataUiDescription)(entity, column.propertyName),
                    s3Pattern: (0, helpers_1.getDataUiS3FileConfig)(entity, column.propertyName),
                    isFilter: (_f = overrides === null || overrides === void 0 ? void 0 : overrides.isFilter) !== null && _f !== void 0 ? _f : true,
                    emptyToNull: (overrides === null || overrides === void 0 ? void 0 : overrides.emptyToNull) || false,
                    isRichText: (overrides === null || overrides === void 0 ? void 0 : overrides.isRichText) || false,
                    allowCloning: (_g = overrides === null || overrides === void 0 ? void 0 : overrides.allowCloning) !== null && _g !== void 0 ? _g : true,
                    filter: searchField === null || searchField === void 0 ? void 0 : searchField.filter,
                };
            }
        }
        return result;
    }
    build() {
        const groups = this.getColumnsByGroup();
        return {
            name: (0, helpers_1.getDataUiName)(this.entity),
            description: (0, helpers_1.getDataUiDescription)(this.entity),
            type: (0, typeorm_entity_metadata_1.getTypeormEntity)(this.entity, this.connection).type,
            endpoint: (0, helpers_1.entityEndpoint)(this.entity),
            permissions: this.getPermissions(),
            groups,
            groupActions: (0, helpers_1.getDataUiActions)(this.entity),
            searchFields: this.getSearchFields(),
            primaryKeys: Object.values(groups.table)
                .filter((c) => c.isPrimary)
                .map((c) => c.propertyName),
        };
    }
}
exports.DataUiTypeOrmBuilder = DataUiTypeOrmBuilder;
class DataUiBlueprints {
    constructor() { }
    static init(crudBasePath, connection) {
        this.crudBasePath = crudBasePath;
        this.connection = connection !== null && connection !== void 0 ? connection : (0, typeorm_1.getConnection)();
        this.cache = new cache_map_1.CacheMap((entity) => {
            return new DataUiTypeOrmBuilder(entity, this.connection).build();
        });
        this.classCache = new cache_map_1.CacheMap((entity) => {
            return (0, helpers_1.getEntityConstructor)(entity, this.connection);
        });
    }
    static getCrudBasePath() {
        return this.crudBasePath;
    }
    static get(entity) {
        entity = this.getEntityConstructor(entity);
        return this.cache.get(entity);
    }
    static getEntityConstructor(entity) {
        return this.classCache.get(entity);
    }
    static getEntityInstance(entityClass) {
        const constructor = this.getEntityConstructor(entityClass);
        const entity = new constructor();
        const description = this.get(entityClass);
        for (const [property, config] of Object.entries(description.groups.form)) {
            if (config.hasDefaultValue) {
                entity[property] = config.defaultValue;
            }
        }
        return entity;
    }
    static cloneEntityInstance(entityClass, instance, cloneRelation) {
        if ((0, common_1.isNullOrUndefined)(instance)) {
            return instance;
        }
        const constructor = this.getEntityConstructor(entityClass);
        const entity = new constructor();
        const description = this.get(entityClass);
        for (const [property, config] of Object.entries(description.groups.form)) {
            if (!cloneRelation && (config.isReadOnly || config.isPrimary)) {
                continue;
            }
            let v;
            switch (config.columnType.type) {
                case types_1.SimplifiedColumnTypeEnum.JSON:
                    v = JSON.parse(JSON.stringify(instance[property]));
                    break;
                case types_1.SimplifiedColumnTypeEnum.RELATION:
                    if (!config.isRelationOwner) {
                        continue;
                    }
                    if (Array.isArray(instance[property])) {
                        v = instance[property].map((el) => this.cloneEntityInstance(config.relationEntity, el, true));
                    }
                    else {
                        v = this.cloneEntityInstance(config.relationEntity, instance[property], true);
                    }
                    break;
                default:
                    v = instance[property];
            }
            if (!cloneRelation || v) {
                entity[property] = v;
            }
        }
        return entity;
    }
}
exports.DataUiBlueprints = DataUiBlueprints;
//# sourceMappingURL=builder.js.map